import { FC, ReactNode, useEffect } from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  dismissable?: boolean;
}

const Modal: FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  className,
  contentClassName,
  dismissable = true,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleDismissable = () => {
    if (dismissable) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-51 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-(--neutral-black-NB1100)/50" onClick={handleDismissable} />

      <div
        className={`relative flex max-h-[calc(100vh-2rem)] w-[calc(100vw-2rem)] max-w-xs flex-col gap-4 overflow-hidden rounded-2xl bg-(--neutral-white-NW1000) p-5 shadow-xl md:max-w-lg lg:max-w-2xl lg:gap-6 lg:rounded-[36px] lg:p-8 ${className ?? ''}`}
      >
        {title && (
          <div className="flex shrink-0 items-center justify-between border-b border-(--neutral-black-NB100) pb-3">
            <h3 className="m-0! text-(--neutral-black-NB1000)! [font-size:var(--fs-h5)]! font-bold! lg:[font-size:var(--fs-h4)]!">
              {title}
            </h3>

            <button onClick={onClose} className="rounded-lg p-2" aria-label="Close modal">
              <X className="h-5 w-5 cursor-pointer text-(--neutral-black-NB600) lg:h-6 lg:w-6" />
            </button>
          </div>
        )}

        <div className={contentClassName ?? 'min-h-0 flex-1 overflow-y-auto'}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
